export default __webpack_public_path__ + "static/media/Asset---4.321d923a.png";